"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ChevronRight_1 = __importDefault(require("../Icons/ChevronRight"));
const styled_1 = require("./styled");
const Modal_1 = __importDefault(require("../Modal"));
const InputAction_1 = __importDefault(require("../InputAction"));
const Search_1 = __importDefault(require("../Icons/Search"));
const List_1 = __importDefault(require("./List"));
const VirtualizedList_1 = __importDefault(require("./VirtualizedList"));
/**
 * Select modal. Custom select box for widgets
 */
const SelectModal = (_a) => {
    var { options, selected, title, subheader, optionsTitle, footer, 
    // footerTitle,
    onSelect, disabled, hasFilter, error, placeholder = 'Select a token', filterPlaceholder, maxWidth, itemHeight, noBorder, highlight = false, callback, autoscroll = false } = _a, rest = __rest(_a, ["options", "selected", "title", "subheader", "optionsTitle", "footer", "onSelect", "disabled", "hasFilter", "error", "placeholder", "filterPlaceholder", "maxWidth", "itemHeight", "noBorder", "highlight", "callback", "autoscroll"]);
    const selectedOption = options.find(i => i.value === selected);
    const [filterValue, setFilterValue] = (0, react_1.useState)('');
    const [filteredOptions, setFilteredOptions] = (0, react_1.useState)(options);
    const modalRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (filterValue) {
            const result = options.filter(item => {
                const value = item.filterKey || item.value.toString();
                const filter = filterValue;
                return value.toLowerCase().includes(filter.toLowerCase());
            });
            setFilteredOptions(result);
        }
        else {
            setFilteredOptions(options);
        }
    }, [filterValue, options]);
    const open = (0, react_1.useCallback)(() => {
        var _a;
        (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.open();
    }, [modalRef]);
    const close = (0, react_1.useCallback)(() => {
        var _a;
        (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.close();
    }, [modalRef]);
    const isLongList = filteredOptions.length > 300;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.Selected, Object.assign({ disabled: disabled, error: error, onClick: () => !disabled && open(), highlight: highlight }, rest),
            !selectedOption ? (react_1.default.createElement("div", null, placeholder)) : (selectedOption.content(true)),
            react_1.default.createElement(ChevronRight_1.default, { size: 12, style: {
                    transform: 'rotateZ(90deg)',
                    cursor: disabled ? 'default' : 'pointer',
                } })),
        react_1.default.createElement(Modal_1.default, { ref: modalRef, title: react_1.default.createElement(react_1.default.Fragment, null, title), contentHeight: isLongList ? '100%' : 'auto', maxWidth: maxWidth, noPadding: true, noBorder: noBorder, subheader: subheader, filter: hasFilter ? (react_1.default.createElement(InputAction_1.default, { placeholder: filterPlaceholder, onChange: (e) => {
                    setFilterValue(e.target.value);
                }, icon: react_1.default.createElement(Search_1.default, null), value: filterValue })) : undefined, callback: callback, setFilterValue: setFilterValue, autoscroll: autoscroll },
            isLongList ? (react_1.default.createElement(VirtualizedList_1.default, { options: filteredOptions, optionsTitle: optionsTitle, itemHeight: itemHeight || 50, onSelect: onSelect, close: close })) : (react_1.default.createElement(List_1.default, { options: filteredOptions, optionsTitle: optionsTitle, onSelect: onSelect, close: close })),
            footer && footer)));
};
exports.default = SelectModal;
//# sourceMappingURL=SelectModal.js.map